import { useHorizontalScroll } from '../../../../hooks/packages/useHorizontalScroll';
import { PackageType, selectCurrentPackage, selectPackageTabs, setPackageTab } from '../../../../features/package/packageSlice';
import { useDispatch, useSelector } from 'react-redux';

interface TypeTabList {
    id: number;
    tabId: number;
    tabName: string;
    type: PackageType;
}

export const tabList: TypeTabList[] = [
    {
        id: 2,
        tabId: 2,
        tabName: "Package",
        type: 'package'
    },
    {
        id: 3,
        tabId: 3,
        tabName: "Product",
        type: 'product'
    },
]

export default function PackageModalTab() {

    const dispatch = useDispatch();
    const currentPackage = useSelector(selectCurrentPackage);
    const selectedTab  = useSelector(selectPackageTabs)
    const { scrollRef, handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove, } = useHorizontalScroll();

    return (
        <div className="mt-3">
            <div
                ref={scrollRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                className="overflow-x-auto flex scrollbar-hide justify-center"
            >
                {tabList.map((tab) => (
                    <button
                        key={tab.id}
                        className={`flex-shrink-0 px-4 py-1 text-sm font-semibold capitalize transition-all duration-200 ${
                            selectedTab === tab.type
                            ? "border-b-2 border-cbColor text-cbColor font-medium"
                            : "border-b-2 border-transparent text-black"
                        }`}
                        onClick={() => dispatch(setPackageTab(tab.type))}
                    >
                        {
                            tab.type === 'package'
                                ? `${tab.tabName}  ${currentPackage?.items.length > 0 ? `(${currentPackage.items.length})` : ""}`
                            : tab.tabName
                        }
                    </button>
                ))}
            </div>
        </div>
    )
}
